module.exports = __webpack_public_path__ + "static/media/login-google.ecdd2208.svg";